module.exports = __webpack_public_path__ + "static/media/hydgreen.e78a92d9.svg";